import { createApp } from "vue"
import { createRouter, createWebHistory } from 'vue-router'

import NavigationComponent from "./components/NavigationComponent.vue";
import SubBanner from "./components/SubBanner.vue";
import DynastiesPage from "./pages/DynastiesPage.vue";
import DynastyPage from "./pages/DynastyPage.vue";
import RelatedPage from "./pages/RelatedPage.vue";
import TimelinePage from "./pages/TimelinePage.vue";
import ErrorPage from "./pages/ErrorPage.vue";

const routes = [
  { 
    path: "/",
    name: "home",
    components: {
      "navigation": NavigationComponent,
      "sub-banner": SubBanner,
      default: DynastiesPage
    }
  },
  {
    path: "/dynasty/:id/:language",
    name: "dynasty",
    components: {
      "navigation": NavigationComponent,
      "sub-banner": SubBanner,
      default: DynastyPage
    }
  },
  {
    path: "/related/:id/:type",
    name: "related",
    components: {
      "navigation": NavigationComponent,
      "sub-banner": SubBanner,
      default: RelatedPage
    }
  },
  {
    path: "/timeline/:id",
    name: "timeline",
    components: {
      "navigation": NavigationComponent,
      "sub-banner": SubBanner,
      default: TimelinePage
    }
  },
  {
    path: "/error",
    name: "error",
    components: {
      "navigation": NavigationComponent,
      "sub-banner": SubBanner,
      default: ErrorPage
    }
  },
  {
      path: "/:pathMatch(.*)*",
      redirect: "/error"
  }
];

// export default new VueRouter({
//   base: "/dynasties/",
//   mode: "history",
//   routes,
//   scrollBehavior() {
//     return window.scrollTo({ top: 0, behavior: "smooth" });
//   }
// });

const router = createRouter({
  history: createWebHistory("/dynasties/"),
  routes,
  scrollBehavior() {
      return window.scrollTo({ top: 0, behavior: "smooth" });
  }
});

export default router;